import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconPeople = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#333333",
		d: "M13.333 9.166c1.384 0 2.492-1.116 2.492-2.5 0-1.383-1.108-2.5-2.492-2.5-1.383 0-2.5 1.117-2.5 2.5 0 1.384 1.117 2.5 2.5 2.5zm-6.666 0c1.383 0 2.491-1.116 2.491-2.5 0-1.383-1.108-2.5-2.491-2.5-1.384 0-2.5 1.117-2.5 2.5 0 1.384 1.116 2.5 2.5 2.5zm0 1.667c-1.942 0-5.834.975-5.834 2.917v2.083H12.5V13.75c0-1.942-3.892-2.917-5.833-2.917zm6.666 0c-.241 0-.516.017-.808.042.967.7 1.642 1.642 1.642 2.875v2.083h5V13.75c0-1.942-3.892-2.917-5.834-2.917z"
	})
});
export default SvgIconPeople;
